module.exports = __webpack_public_path__ + "img/Logo-LeeLee.c2dc4147.png";